import React from 'react';
import './Services.css';
import { useTranslation } from '../../i18n/TranslationContext';

interface ServiceType {
  icon: string;
  key: string;
  image?: string;
}

const servicesInfo: ServiceType[] = [
  {
    icon: 'fas fa-tree',
    key: 'landscaping',
    image: '/img/services/landscaping.jpg'
  },
  {
    icon: 'fas fa-truck',
    key: 'excavation',
    image: '/img/excavation-a.jpg'
  },
  {
    icon: 'fas fa-ruler',
    key: 'leveling',
    image: '/img/services/leveling.jpg'
  },
  {
    icon: 'fas fa-snowflake',
    key: 'snowRemoval',
    image: '/img/services/snow-removal.jpg'
  },
  {
    icon: 'fas fa-tint',
    key: 'drainage',
    image: '/img/services/drainage.jpg'
  },
  {
    icon: 'fas fa-tools',
    key: 'installation',
    image: '/img/services/installation.jpg'
  }
];

const Services: React.FC = () => {
  const { t } = useTranslation();
  const [activeService, setActiveService] = React.useState<string | null>('excavation');

  const handleServiceClick = (key: string) => {
    setActiveService(key);
  };

  const getActiveServiceDetails = () => {
    const activeKey = activeService || 'excavation';
    return {
      title: t.services.items[activeKey].title,
      description: t.services.items[activeKey].description,
      image: servicesInfo.find(s => s.key === activeKey)?.image || ''
    };
  };

  const activeDetails = getActiveServiceDetails();

  return (
    <section id="services" className="services-section">
      <div className="services-glow"></div>
      <div className="container">
        <h2 className="section-title">{t.services.title}</h2>
        
        <div className="services-showcase">
          <div className="services-list">
            {servicesInfo.map((service) => (
              <div 
                key={service.key} 
                className={`service-tab ${activeService === service.key ? 'active' : ''}`}
                onClick={() => handleServiceClick(service.key)}
              >
                <div 
                  className="service-tab-icon"
                  style={{ 
                    backgroundColor: activeService === service.key ? '#33b44a' : '#222'
                  }}
                >
                  <i 
                    className={service.icon} 
                    style={{ 
                      color: activeService === service.key ? '#000' : '#ffffff',
                      fontSize: '22px'
                    }}
                  ></i>
                </div>
                <div className="service-tab-content">
                  <h3>{t.services.items[service.key].title}</h3>
                </div>
              </div>
            ))}
          </div>
          
          <div className="service-details">
            <div className="service-details-content glass-panel">
              <h3>{activeDetails.title}</h3>
              <p>{activeDetails.description}</p>
              <a href="#contact" className="btn service-btn">
                <i className="fas fa-phone-alt"></i>
                {t.hero.cta}
              </a>
            </div>
            <div className="service-details-image">
              <div className="image-container">
                <div className="image-overlay"></div>
                <div 
                  className="image-bg" 
                  style={activeDetails.image ? {backgroundImage: `url(${activeDetails.image})`} : undefined}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;